export { ModularPageComponent } from "./ModularPageComponent";
